module.exports = __webpack_public_path__ + "37ba7b92/img/scraper-icon.df6ccde5.svg";